import axios from 'axios';
import Util from '../Util'

class EntryCheckAPI {

    constructor() {
        this.apiHost = process.env.VUE_APP_API_HOST;
    }

    // 入力チェック一覧を取得する（SPEC-037）
    // data - { toDate: "YYYY-MM-DD", days: 1〜31 }
    // Excel 出力もこの API で締め期間のデータを取得し、クライアントで生成する。
    getData(data){

        let path = "/entrycheck";

        let endpoint =  Util.combineUrl(this.apiHost, Util.buildApiPath(path));

        return axios.post(endpoint,data).then(response => Util.addSnakeCaseAliasesDeep(Util.toCamelCaseDeep(response.data)))
    }

}

let _api = new EntryCheckAPI();

export default _api;
